<template>
    <div>
        <div ref="inlineDatepicker"></div>
    </div>
</template>

<script>
export default {
    props: {
        startDate: {
            default: 'today'
        },

        endDate: {
            default: ''
        },

        weekStart: {
            default: 0
        },

        disabledDays: {
            default: function () {
                return []
            }
        },

        disabledDates: {
            default: function () {
                return []
            }
        }
    },

    mounted() {
        let self = this,
            input = this.$refs.inlineDatepicker

        $(input).datepicker({
            language: 'hr',
            format: 'yyyy-mm-dd',
            startDate: this.startDate,
            endDate: this.endDate,
            weekStart: this.weekStart,
            daysOfWeekDisabled: this.disabledDays,
            datesDisabled: this.disabledDates
        }).on('changeDate', function (e) {
            self.$emit('input', e.format())
        })
    },

    watch: {
        disabledDates: function (newVal, oldVal) {
            if (!_.isEqual(newVal, oldVal)) {
                let input = this.$refs.inlineDatepicker

                $(input).datepicker('setDatesDisabled', this.disabledDates)
            }
        }
    }
}
</script>
